import React from 'react';
import MriSimmonsLogo from '../components/common/MriSimmonsLogo';
import WarningIcon from '../components/common/Icons/WarningIcon';

const CheckIcon = () => (
  <svg
    className="unlock-success-icon"
    x="0px"
    y="0px"
    viewBox="0 0 426.667 426.667"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: '#1e8a09' }}
      d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"
    />
  </svg>
);

const uRLToArray = url => {
  const request = {};
  const pairs = url.substring(url.indexOf('?') + 1).split('&');
  for (let i = 0; i < pairs.length; i += 1) {
    if (!pairs[i]) {
      continue;
    }
    const pair = pairs[i].split('=');
    request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return request;
};

const InfoMessage = () => {
  const { href } = window.location;
  let str = href;
  const lastIndex = str.lastIndexOf('#');
  str = str.substring(0, lastIndex);
  const { message, success, error } = uRLToArray(str);

  const backToLogin = () => {
    window.location = '/';
  };
  let isSuccess = false;
  if (
    (typeof success === 'boolean' && success) ||
    success === 'true' ||
    (typeof error === 'boolean' && !error) ||
    error === 'false'
  ) {
    isSuccess = true;
  }

  return (
    <div className="unlock-screen">
      <div className="unlock-card-box">
        <div className="unlock-card">
          <div className="unlock-card-header">
            <div className="mri-simmons-logo">
              <MriSimmonsLogo height={66} width={336} />
            </div>
          </div>
          <div className="unlock-card-body">
            {isSuccess ? <CheckIcon /> : <WarningIcon />}
            <div className="unlock-message">{message}</div>
            <button type="button" onClick={backToLogin}>
              &lt; Back to login
            </button>
          </div>
          <div className="unlock-card-footer">
            If you do not remember your password you can now use the Forgot
            Password link on the login page to reset
          </div>
        </div>
        <div className="unlock-footer-message">
          Need more help? Please contact the system administrator.
        </div>
      </div>
    </div>
  );
};

export default InfoMessage;
